import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CmtSearch from "@coremat/CmtSearch";
import { Box } from "@material-ui/core";
import EventsRequests from "services/events";
import SectionTicketsTable from "./SectionTicketsTable";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  searchBoxContainer: {
    paddingInline: "30px",
    paddingBlock: "16px",
    display: "flex",
    alignItems: "center",
  },
}));

const SectionTicketsContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [searchVal, setSearchVal] = useState("");

  useEffect(() => {
    if (id) {
      dispatch(EventsRequests.getSectionTicketsById(id));
    }
  }, [id, dispatch]);

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.searchBoxContainer}>
          <CmtSearch
            border={false}
            onlyIcon={false}
            iconPosition="left"
            align="left"
            placeholder="جست و جو"
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
          />
          {/* <Typography>تعداد {fillFormTotalDocs} نتیجه یافت شد.</Typography> */}
        </Box>
        <SectionTicketsTable />
      </CmtCardContent>
    </CmtCard>
  );
};

export default SectionTicketsContainer;
